<template> 
    <li class="nav-item dropdown pr-2">
        <a id="cartDropdown" class="nav-link dropdown-toggle"
            href="#" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false"
        >
            <span class="badge badge-pill badge-dark">
                <i class="fa fa-shopping-cart"></i> {{ cartcount }}
            </span>
        </a>

        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="cartDropdown" style="width: 450px; padding: 0px; border-color: #9DA0A2">
            <ul class="list-group" style="margin: 20px;">
                <li class="list-group-item" v-if="!cart">Your Cart is Empty</li>
                <li class="list-group-item" v-for="item in cart" :item='item' :key="item.id">
                    <div class="row">
                        <div class="col-lg-3">
                            <img :src="item.attributes.image_path !== null ? '/storage/'+item.attributes.image_path : '/images/WillCall_NoImage_500.jpg'" class="img-fluid" style="width: 50px; height: 50px;" alt="product image">
                        </div>
                        <div class="col-lg-6">
                            <b>{{item.name}}</b>
                            <br><small>Qty: {{item.quantity}}</small>
                        </div>
                        <div class="col-lg-3">
                            <p>
                                {{ '$' + (item.quantity * item.price).toFixed(2) }} 
                                <button class="btn btn-secondary btn-sm" :data-id="item.id" @click="deleteItem"><i class="fa fa-trash"></i></button>
                            </p>
                        </div>
                        <hr>
                    </div>
                </li>
                <li class="list-group-item" v-if="cart">
                    <br>
                    <div class="row">
                        <div class="col-lg-9">
                            <b>Total: </b>{{ '$' + carttotal.toFixed(2) }}
                        </div>
                        <div class="col-lg-3">
                            <form action="/cart/clear" method="POST">
                                <input type="hidden" name="_token" :value="csrf">
                                <button class="btn btn-danger btn-sm">Clear</button>
                            </form>
                        </div>
                    </div>
                </li>
                <div class="row" style="margin: 0px;" v-if="cart">
                    <br>
                    <a class="btn btn-dark btn-sm btn-block showloading" href="/cart">
                        CART <i class="fa fa-arrow-right"></i>
                    </a>
                    <a class="btn btn-dark btn-sm btn-block showloading" href="/checkout">
                        CHECKOUT <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </ul>
        </div>
    </li>
</template>

<script>
    export default {
        props: ['cart','cartcount','carttotal'],
        data () {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        mounted() {
            console.log('Component mounted.')
        },
        methods: {
            deleteItem() {
                $.sweetModal.confirm('Remove Item', 'Do you want to remove this item?', function() {
                    axios.post('/cart/remove', {id: $(event.target).data('id')}).then(response => {  
                        Event.fire('updateCart',{}); 
                        $.sweetModal('Item removed from cart!');
                    });
                });
            }
        }
    }
</script>
